<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.4438 11.8924L14.1375 3.708C14.1203 3.69071 14.0998 3.67699 14.0773 3.66762C14.0548 3.65826 14.0306 3.65344 14.0063 3.65344C13.9819 3.65344 13.9577 3.65826 13.9352 3.66762C13.9127 3.67699 13.8922 3.69071 13.875 3.708L8.28047 9.2205C8.24526 9.25543 8.22526 9.30285 8.22483 9.35244C8.22439 9.40203 8.24354 9.4498 8.27813 9.48534L8.28047 9.48769L9.21797 10.4111L6.47109 13.1135C6.43589 13.1484 6.41589 13.1958 6.41545 13.2454C6.41501 13.295 6.43417 13.3428 6.46875 13.3783L6.47109 13.3807L7.39688 14.2924L2.96484 18.6752H1.68984C1.58672 18.6752 1.5 18.7596 1.5 18.8627V20.1564C1.5 20.2596 1.58438 20.3439 1.6875 20.3439H9.77109C9.82031 20.3439 9.86719 20.3252 9.90234 20.29L11.6859 18.5182L12.6328 19.451C12.65 19.4683 12.6705 19.482 12.693 19.4913C12.7155 19.5007 12.7397 19.5055 12.7641 19.5055C12.7885 19.5055 12.8126 19.5007 12.8351 19.4913C12.8577 19.482 12.8781 19.4683 12.8953 19.451L15.6398 16.7416L16.5797 17.6674C16.5969 17.6847 16.6173 17.6984 16.6399 17.7077C16.6624 17.7171 16.6865 17.7219 16.7109 17.7219C16.7353 17.7219 16.7595 17.7171 16.782 17.7077C16.8045 17.6984 16.825 17.6847 16.8422 17.6674L22.4367 12.1549C22.5164 12.0846 22.5164 11.9674 22.4438 11.8924ZM9.13594 18.6611H5.38125L8.53125 15.5439L10.4086 17.3932L9.13594 18.6611ZM12.7641 17.2057L8.74688 13.2471L10.3547 11.6627L14.3719 15.6213L12.7641 17.2057ZM16.7133 15.4221L10.5539 9.35409L14.0063 5.95331L20.1656 12.0236L16.7133 15.4221Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Highlight' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
